module.exports = __webpack_public_path__ + "img/poster.e8b7ccd0.jpg";